import { bopApi } from '@/lib/api/client';

const PATH = 'v1/exchange/maintenance';
const ALLOWLIST_PATH = `${PATH}/allowlist`;

export type ExchangeMaintenanceState = 'on' | 'off';

export const ALLOWLIST_SEGMENTS = ['BROKER', 'MARKET_MAKER', 'INSTITUTIONAL', 'RETAIL'] as const;
export type AllowlistSegment = (typeof ALLOWLIST_SEGMENTS)[number];

/** Who is let through while maintenance is on: callers in a listed segment, or acting for a listed account holder. */
export interface ExchangeMaintenanceAllowlist {
  segments: AllowlistSegment[];
  account_holder_ids: string[];
}

export interface ExchangeMaintenanceResponse {
  state: ExchangeMaintenanceState;
  /** Stored with the state: who is let through while maintenance is on. */
  allowlist: ExchangeMaintenanceAllowlist;
  /** Server-side allowlist: exchange admins and DevOps (plus QA outside production). */
  canEdit: boolean;
  /** PUT only: whether brokers were sent the EXCHANGE_MAINTENANCE_STARTED / _ENDED webhook. */
  brokersNotified?: boolean;
}

export const getExchangeMaintenance = () => bopApi.get(PATH).json<ExchangeMaintenanceResponse>();

/** `comment` is the audit justification, as for freeze/kill. */
export const setExchangeMaintenance = (state: ExchangeMaintenanceState, comment: string) => bopApi.put(PATH, { json: { state, comment } }).json<ExchangeMaintenanceResponse>();

/** Replaces the whole allowlist; `comment` is the audit justification. */
export const setExchangeMaintenanceAllowlist = (allowlist: ExchangeMaintenanceAllowlist, comment: string) =>
  bopApi.put(ALLOWLIST_PATH, { json: { ...allowlist, comment } }).json<{ state: ExchangeMaintenanceState; allowlist: ExchangeMaintenanceAllowlist }>();
